import React from 'react'
import { Component } from 'react';
import { connect } from "react-redux";
import { getAboutUs } from '../../actions/home'



class about extends Component{
    constructor(){
        super()
    }
    render(){
        const {aboutContent} = this.props; 
if(aboutContent !== null && aboutContent)
{
    console.log()


}
        return(
            <section style={{paddingTop:10}}>
                 <div className="breadcrumb-section" style={{
    background: 'var(--theme-color)',
    color: 'white'
}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                        <div className="page-title" style={{display:'block',textAlignLast:'center'}}>
                               <h2 style={{fontSize:22,color:'white'}} >
                               {aboutContent !== null && aboutContent ? 
                             aboutContent[0].SSD_ECOM_PAGE_NAME : '' }
                               </h2>
                               </div>
                        </div>
                    </div>
                </div>
            </div>
            <br></br>
                <div className='container'>
                   
                    <div className='row'>
<div className='col'>
    <p style={{fontSize:16,lineHeight:2}}>
    {aboutContent !== null && aboutContent ? 
                             aboutContent[0].SSD_ROWID_DESCRIPTION : '' }
        </p>
</div>
                    </div>

                </div>
            </section>
        )
    }
}
function mapStateToProps(state) {
	return {
		logo: state.tenant.tenantLogoURL,
		isAuth: state.user.isAuth,
		connection_id: state.tenant.connection_id,
		loading: state.landing.aboutLoading,
		error: state.landing.error,
		aboutContent: state.landing.aboutContent,
		
	}
}

export default connect(mapStateToProps ,{getAboutUs})(about)
